import { Tooltip } from "antd";
import React from "react";

const DisabledWithReason = ({ disabled, reason, children }) => {
  if (!disabled) {
    return children;
  }
  return (
    <Tooltip title={reason}>
      <span>{children}</span>
    </Tooltip>
  );
};

export default DisabledWithReason;
